const FlagOther = () => (
  <svg xmlns='http://www.w3.org/2000/svg' width='23' height='15.279' viewBox='0 0 23 15.279'>
    <defs>
      <style>
        {'.a{fill:#bdc3c7;}'}
        {'.b{fill:#fff;font-size:8px;font-family:FiraSans-Regular, Fira Sans;}'}
      </style>
    </defs>
    <g transform='translate(0 0.201)'>
      <g transform='translate(0 -0.201)'>
        <rect className='a' width='22.732' height='15.279' transform='translate(0 0)' />
      </g>
      <text className='b' transform='translate(0 2.799)'>
        <tspan x='1.2' y='7'>
          Outro
        </tspan>
      </text>
    </g>
  </svg>
)

export { FlagOther }
